module.exports = __webpack_public_path__ + "img/fo.5548d2d0.svg";